import { cn } from '@ahm/common-helpers';
import type { ComponentProps, HTMLAttributes } from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../avatar';
export type AIMessageProps = HTMLAttributes<HTMLDivElement> & {
  from: 'user' | 'assistant';
};
export const AIMessage = ({ className, from, ...props }: AIMessageProps) => (
  <div
    className={cn(
      'group animate-message-in flex w-full items-end justify-end gap-2 py-2.5',
      from === 'user' ? 'is-user' : 'is-assistant flex-row-reverse justify-end',
      className
    )}
    {...props}
  />
);
export type AIMessageContentProps = HTMLAttributes<HTMLDivElement>;
export const AIMessageContent = ({
  children,
  className,
  ...props
}: AIMessageContentProps) => (
  // <div
  //   className={cn(
  //     'rounded-lg bg-gradient-to-b from-primary-60 via-yellow-30 to-secondary-50 p-[1px] group-[.is-user]:p-0'
  //   )}
  // >
  <div
    className={cn(
      'flex max-w-[85%] flex-col gap-2 rounded-2xl px-4 py-2.5 text-sm leading-relaxed',
      'border border-neutral-10 bg-white text-foreground shadow-sm',
      'group-[.is-assistant]:rounded-bl-md',
      'group-[.is-user]:rounded-br-md group-[.is-user]:border-none group-[.is-user]:bg-gradient-to-br group-[.is-user]:from-primary-40 group-[.is-user]:to-primary-50 group-[.is-user]:font-medium group-[.is-user]:text-white group-[.is-user]:shadow-[0_4px_14px_-4px_rgba(254,95,0,0.45)]',
      className
    )}
    {...props}
  >
    <div className="is-user:dark">{children}</div>
  </div>
);
export type AIMessageAvatarProps = ComponentProps<typeof Avatar> & {
  src: string;
  name?: string;
};
export const AIMessageAvatar = ({
  src,
  name,
  className,
  ...props
}: AIMessageAvatarProps) => (
  <Avatar className={cn('size-8', className)} {...props}>
    <AvatarImage alt="" className="my-0" src={src} />
    <AvatarFallback>{name?.slice(0, 2) ?? 'ME'}</AvatarFallback>
  </Avatar>
);
